import React, { useEffect, useState } from "react";

const AddressPage = () => {
  const [addresses, setAddresses] = useState([]);
  const [form, setForm] = useState({});

  useEffect(() => {
    fetchAddresses();
  }, []);

  const fetchAddresses = async () => {
    const res = await fetch("https://lappyshop.onrender.com/api/get-address", {
      credentials: "include",
    });
    const data = await res.json();
    if (data.success) setAddresses(data.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await fetch("https://lappyshop.onrender.com/api/add-address", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    fetchAddresses();
  };

  return (
    <div className="p-2 md:p-4">

      <h2 className="text-lg md:text-xl font-semibold mb-4">
        Manage Addresses
      </h2>

      {/* FORM */}
      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 md:grid-cols-2 gap-3 bg-white p-4 rounded-xl shadow"
      >
        {["fullName","phone","pincode","state","city","addressLine","landmark"].map((field) => (
          <input
            key={field}
            placeholder={field}
            className="border p-2 rounded text-sm"
            onChange={(e) => setForm({ ...form, [field]: e.target.value })}
          />
        ))}

        <button className="col-span-2 bg-black text-white py-2 rounded">
          Add Address
        </button>
      </form>

      {/* LIST */}
      <div className="mt-4 space-y-3">
        {addresses.map((addr) => (
          <div key={addr._id} className="bg-white p-3 rounded shadow text-sm">
            <p className="font-semibold">{addr.fullName}</p>
            <p>{addr.addressLine}, {addr.city}</p>
          </div>
        ))}
      </div>

    </div>
  );
};

export default AddressPage;